import React, { useMemo, useState } from 'react';
import CatalogueSection from '../sections/CatalogueSection';

export default function CataloguePage({ pets, onAddToCart, whatsappUrl }) {
  const [availableOnly, setAvailableOnly] = useState(true);
  const [sex, setSex] = useState('All');
  const [query, setQuery] = useState('');

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    return pets.filter((p) => {
      const s = String(p.status || '').trim().toLowerCase();
      const isUnavailable = s === 'sold' || s === 'not available' || s === 'unavailable' || s === 'out of stock';
      if (availableOnly && isUnavailable) return false;
      if (sex !== 'All' && String(p.sex || '').toLowerCase() !== sex.toLowerCase()) return false;
      if (!q) return true;
      return (
        String(p.title || '').toLowerCase().includes(q) ||
        String(p.breed || '').toLowerCase().includes(q) ||
        String(p.sex || '').toLowerCase().includes(q)
      );
    });
  }, [pets, availableOnly, sex, query]);

  return (
    <div className="page catalogue-page">
      <div className="catalogue-filters">
        <div className="catalogue-filters-inner">
          <div className="catalogue-filters-title">Find a pup</div>
          <div className="catalogue-filters-row">
            <label className="toggle" aria-label="Show available only">
              <input
                type="checkbox"
                checked={availableOnly}
                onChange={(e) => setAvailableOnly(e.target.checked)}
              />
              <span className="toggle-ui" aria-hidden="true" />
              <span>Available only</span>
            </label>

            <div className="chips" role="group" aria-label="Sex filter">
              {['All', 'Female', 'Male'].map((v) => (
                <button
                  key={v}
                  type="button"
                  className={`chip ${sex === v ? 'is-active' : ''}`}
                  onClick={() => setSex(v)}
                >
                  {v}
                </button>
              ))}
            </div>

            <label className="catalogue-search" aria-label="Search pups">
              <input
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="Search by name or breed…"
              />
            </label>
          </div>
          <div className="catalogue-filters-meta">{filtered.length} pups</div>
        </div>
      </div>

      <CatalogueSection pets={filtered} onAddToCart={onAddToCart} whatsappUrl={whatsappUrl} />
    </div>
  );
}
